<div
  class="branches"
  role="radiogroup"
  [attr.aria-labelledby]="labelledBy"
  [attr.aria-describedby]="describedBy"
>
  @for (branch of branches; track branch.branchCode; let i = $index) {
    <button
      #branchOption
      type="button"
      class="br"
      role="radio"
      [attr.aria-checked]="branch.branchCode === selectedBranchCode"
      [attr.tabindex]="isTabbable(branch, i) ? 0 : -1"
      (click)="select(branch)"
      (keydown)="onKeydown($event, i)"
    >
      <span class="br-ic" aria-hidden="true">
        @switch (iconFor(branch)) {
          @case ('army') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3l7 3v6c0 4-3 7-7 8-4-1-7-4-7-8V6z" />
            </svg>
          }
          @case ('navy') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 15h18l-2 5H5zM12 3v9M7 8h10" />
            </svg>
          }
          @case ('marines') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 2.5l2.6 6.4 6.9.5-5.3 4.4 1.7 6.7L12 16.9 6.1 20.5l1.7-6.7L2.5 9.4l6.9-.5z"
              />
            </svg>
          }
          @case ('air') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M2 13l20-7-7 20-2.5-8z" />
            </svg>
          }
          @case ('space') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3a9 9 0 1 0 9 9M12 3v9l6.5 6.5" />
            </svg>
          }
          @case ('coast') {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3v18M4 9h16M6 15c3 3 9 3 12 0" />
            </svg>
          }
          @default {
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 3l7 3v6c0 4-3 7-7 8-4-1-7-4-7-8V6z" />
            </svg>
          }
        }
      </span>
      <span class="br-n">{{ branch.branchTitle }}</span>
    </button>
  }
</div>
